import type { CommentsContent } from '@/blocks/domain/types/BlockContent/ProseContent';
import { fromProseContent, mapProseContent, type ProseContentDtoFor } from '@/blocks/application/mappers/blockProseMapper';

export function mapCommentsContent(dto: ProseContentDtoFor<'comments'>): CommentsContent {
  return mapProseContent(dto) as CommentsContent;
}

export function fromCommentsContent(content: CommentsContent): ProseContentDtoFor<'comments'> {
  return fromProseContent(content) as ProseContentDtoFor<'comments'>;
}
